import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";
import type { PaginationParams } from "@/types/api";

import { auditLogApi } from "./auditLogApi";
import { entityHistoryKeys } from "./entityHistoryQueryKeys";
import type { EntityHistoryResponse } from "./types";

export const useGetAuditLogsQuery = (
  params?: PaginationParams,
  options = {}
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.auditLog, params],
    queryFn: () => auditLogApi.getAuditLogs(params),
    ...options,
  });
};

export const useGetEntityHistory = ({
  entityId,
  entityType,
  params,
  options,
}: {
  entityId?: string;
  entityType?: string;
  params?: PaginationParams;
  options?: UseQueryOptions<EntityHistoryResponse, Error>;
}): UseQueryResult<EntityHistoryResponse> => {
  return useQuery<EntityHistoryResponse, Error>({
    queryKey: entityHistoryKeys.query(entityId ?? entityType, params),
    queryFn: () => {
      if (entityType) {
        return auditLogApi.getEntityHistoryByType(entityType, params);
      }

      return auditLogApi.getEntityHistory(entityId!, params);
    },
    enabled: !!entityId || !!entityType,
    ...options,
  });
};
